<template>
  <div style="padding: 20px">
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号隐私政策概要
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们非常注重保护用户（
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        “
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">您</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ”
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        ）的个人信息及隐私，并希望通过本概要向您简洁介绍我们如何收集、使用和保护您的个人信息。
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        本概要为《腾宇一号隐私政策》的附件，如您希望了解我们详细的隐私政策，请查阅概要后的隐私政策正文。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        一、我们如何收集和使用您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        注册信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在您注册成为
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        用户时，您需要至少提供手机号码以创建
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        账号，并完善相关的网络身份识别信息（如头像、昵称及登录密码等）；如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户以及提供上述信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        地理位置
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        使用目的：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        经您授权，我们会收集您的地理位置信息，以便为您推荐周边的服务。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息说明：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        位置信息的来源包括
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        IP
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        地址、
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        GPS
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        以及能够提供相关信息的
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        WLAN
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        （如
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        Wi-Fi
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">）</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        接入点、蓝牙和基站等传感器信息。您使用服务中提供的信息中可能包含相应地理位置信息，例如您在账号资料中设置的地区信息或您上传的图片、视频中的地理标记信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        当您拒绝位置授权后仍然可以手动选择或输入位置信息，不会影响您使用基本服务。请您知悉，在个别场景下位置是必要的信息，如果您不同意授权位置信息则可能会影响您的正常使用。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        相机
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        使用目的：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        经您授权，我们会收集您的相机信息，以便为您提供扫码、拍照等功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息说明：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们仅在您使用对应功能时收集相应信息，例如您使用扫码拍照等功能时。不同的系统显示的名称可能有所差异，如相机、摄像头等。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以自行选择开启或关闭相机的授权，一旦关闭您将可能无法使用扫码、拍照等功能，但不会影响您使用浏览等基本服务。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        相册
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        使用目的：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        经您授权，我们会收集您的相册信息，以便为您上传和保存照片、视频等功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息说明：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们仅在您使用对应功能时收集相应信息，例如您使用上传和保存照片、视频等功能时。不同的系统显示的名称可能有所差异，如相册、存储权限等。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以自行选择开启或关闭相册的授权，一旦关闭您将可能无法通过上传图片、视频等方式来发布评价等功能，但不会影响您使用浏览等基本服务。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        麦克风
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        使用目的：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        经您授权，我们会收集您的录音信息，以便为您提供语音搜索等语音交互功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息说明：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们仅在您使用对应功能时收集相应信息，通过申请麦克风权限以便获得声音，以提供对应的识别后续的交互功能。不同的系统显示的名称可能有所差异，如麦克风、录音权限等。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以自行选择开启或关闭麦克风授权，一旦关闭您将可能无法使用诸如
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        “
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        按住说话
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ”
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、语音交互等相关功能，但不会影响您使用浏览等基本服务。麦克风权限需要您的额外授权，您也可以在系统权限中自主控制，我们绝不会私自开启您的麦克风权限，更不会非法利用非法手段进行相关信息的收集和使用，请您放心。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        设备信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        使用目的：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在您访问或使用我们服务的过程中，我们会收集您的设备信息，以便获取屏幕分辨率等信息进行界面展示、避免其他设备的异常登录、留存必要的日志信息，从而保障您的账号安全、交易安全和系统运行安全。此外，如您未登录账号，我们使用您的设备信息以便为您推送对应的信息展示。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息说明：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们收集的设备状态包括您的设备型号，
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        IMEI/android
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ID/IDFA/OPEN
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        UDID/GUID/OAID
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">、</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        SIM
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">卡</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        IMSI
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">、</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ICCID
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        信息等设备标识符、设备
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        MAC
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        地址、移动应用列表、电信运营商等。
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        未经您的授权，我们不会提前获取以上信息
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        。目前多数手机终端厂商支持对设备标识符的更改，以保障您对个人信息的自主控制，具体撤回或更改的方式可参见您所使用的终端设备说明。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        您使用过程中主动提供的信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        使用目的：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在您使用我们提供的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务过程中，我们根据您使用的特定场景可能会收集您提供的个人信息，以实现您所需要使用的功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息说明：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们会根据具体的场景请求您提供对应的信息并会严格依法保护您的个人信息，例如撰写带图评价时需要提供昵称、头像、相关评价图片
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        视频等发布内容。此外，如果您愿意额外补充您的性别、生日、喜好、常居地等个人资料，将有助于我们为您提供更加个性化的服务，但如果您不提供该等信息，不会影响您使用我们产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        除法律另有规定外，我们仅会在实现目的所必需的最短时间内留存您的相关个人信息。如您希望详细了解我们所收集的具体各项个人信息及对应的场景，请查阅概要后的隐私政策正文。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        二、您如何管理您的信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您有权管理您的个人信息，包括查询、更正和删除您的账号信息、地址信息、搜索记录、评论信息，改变您授权同意的范围或撤回授权，以及注销您的账号。您可以通过我们的
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        中提供的功能设置进行上述操作。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        如果您无法通过上述方式进行管理，您可以通过我们以下提供的联系方式联系我们，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">我们将在</span>
      <span style="font-family: Helvetica; font-size: 10pt">15</span>
      <span style="font-family: 宋体; font-size: 10pt">天内回复您的要求。</span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        三、您如何联系我们
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以通过
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        上提供的在线联系方式与我们联系，我们将在
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        15
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        天内答复您的请求。
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: center;
      "
    >
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号隐私政策
      </span>
    </p>
    <p
      style="
        background-color: #ffffff;
        line-height: 13.75pt;
        margin: 5pt 0pt;
        text-align: right;
      "
    >
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        生效日期：
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2021
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        年
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      ></span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        12
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      ></span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        月
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      ></span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      ></span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        日
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        （以下或称
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        “
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ”
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        ）非常注重保护用户（
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        “
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">您</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ”
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        ）的个人信息及隐私，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们希望通过本隐私政策向您清晰地介绍在使用我们的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务时，我们如何处理您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        本政策将帮助您了解以下内容：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、我们如何收集和使用您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、我们如何使用
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        Cookie
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        和同类技术
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        3
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、我们如何共享、转让、公开披露您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        4
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、我们如何保存和保护您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        5
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、您如何管理您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        6
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、通知和修订
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        7
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、如何联系我们
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        8
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        、附录
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        【特别提示】请您在使用我们提供的各项产品
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        /
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并作出相应选择
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      >
        。
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        一旦您使用或继续使用我们的产品
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        /
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        如对本隐私政策有任何疑问，您可以通过本隐私政策
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        “
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        如何联系我们
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        ”
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        中提供的方式与我们联系）
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        &#xa0;
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: underline;
        "
      >
        。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务是由
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      ></span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      >
        深圳腾宇一号科技
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      ></span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        有限公司
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        （注册地址：
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      ></span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      >
        深圳市南山区粤海街道蔚蓝海岸社区中心路
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          text-decoration: underline;
        "
      >
        3008
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          text-decoration: underline;
        "
      >
        号
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          text-decoration: underline;
        "
      >
        T7-2101
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        ）及其关联方提供者通过下述途径向您提供的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务：包括但不限于
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        等客户端以及相关微信开放平台账号或小程序等。针对某些特定的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务，我们还将制定单独的隐私政策，向您说明这些产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务的特殊政策。如相关特定的隐私政策与本隐私政策有不一致之处，适用该特定隐私政策。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        请您注意，本政策不适用于您通过我们的产品
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        /
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        服务而接入的其他第三方产品
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        /
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        服务
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        (“
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        其他第三方
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ”
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ，包括您的交易相对方、任何第三方网站以及第三方服务提供者等
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        )
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ，具体规定请参照该第三方的隐私政策或类似声明。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        一、我们如何收集和使用您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在您使用我们的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务时，您需要
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        可以选择授权我们收集和使用个人信息的场景包括：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        1
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、为了向您提供我们产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务的基本功能，您需要授权我们收集、使用必要信息的情形，如您拒绝提供前述必要信息，您将无法正常使用我们的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        2
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、为了向您提供我们产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务的拓展功能，您可以选择授权我们收集、使用信息的情形，如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果，但并不会影响您正常使用我们产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （一）您需要授权我们收集和使用个人信息的场景
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们会遵循正当、合法、必要的原则，出于本政策所述的下列目的收集和使用您的个人信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、帮助您成为我们的用户
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为遵守法律法规的要求，以及向您提供更个性化、更便捷的服务，在您注册成为
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        用户时，您需要至少提供手机号码以创建
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        账号，并完善相关的网络身份识别信息（如头像、昵称及登录密码等）；如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户以及提供上述信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        在提供账号信息的过程中，如果您愿意额外补充如下个人信息，将有助于我们向您提供更为个性化的服务：包括您的性别、生日、常居地、家乡、喜好、家庭信息等。如果您不提供该等信息，不会影响您享受腾宇一号服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        如您选择授权使用第三方账号登录时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的腾宇一号账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、向您提供基于地理位置的信息展示
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为了提升我们的服务表现、效率和功能，经您授权我们会收集您在使用我们服务过程中产生的相关信息，包括：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ）位置信息。当您通过系统授权开启移动设备的定位功能并使用基于位置提供的服务时，我们会收集和使用您的位置信息以便为您推荐周边的服务
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        。
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们会使用有关技术获取您的
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        位置信息
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        （准确度会有所不同），这些技术包括
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        IP
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        地址、
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        GPS
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        以及能够提供相关信息的
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        WLAN
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        （如
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        Wi-Fi
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">）</span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        接入点、蓝牙和基站等。
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您使用服务中提供的信息中可能包含相应地理位置信息，例如您在账号资料中设置的地区信息或您上传的图片、视频中的地理标记信息。您可以在移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ）日志信息。
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        当您使用我们提供的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务时，我们会收集您的浏览、搜索、点击、收藏、关注、分享、发布等信息并作为有关网络日志进行保存，其中包括您的
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        IP
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、电信运营商、网络请求等。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        如您上传的信息中包含您的身份信息、联络信息、行程信息、住宿信息、支付信息等，这些都属于敏感信息，请您谨慎向他人展示或对外提供
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        3
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为您提供收藏、关注、分享、推荐功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为了便于您管理自己的偏好，寻找具有共同爱好的用户或社区，获得更轻松的访问体验，与好友及第三方进行分享等，您可以收藏
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        关注
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        加入您感兴趣的用户，也可以通过功能组件向第三方进行信息分享，我们会收集您在使用上述功能中产生的日志信息，用于在个人主页中向您展示、实现在线管理、发起共享以及向您推荐具有共同爱好的用户等。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        4
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为您提供撰写
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        评价
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        等信息发布功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您在
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        上主动对
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        其他用户
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务进行评价或发布其他内容（如分享心情、状态、签到、攻略等信息）时，我们将收集您发布的信息，并展示您的昵称、头像和发布内容等。如您选择以匿名方式发布评价信息时，我们将不展示您的昵称、头像。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        5
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、帮助您完成支付
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您在
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        上进行订单支付时，您可以选择
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        的第三方合作机构（如微信支付、
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        QQ
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        钱包、
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        Apple Pay
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、支付宝等合作方）所提供的服务进行支付。我们需要收集您的
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        订单信息、对账信息及其他法律要求的必要信息并与这些合作机构共享，以确认您的支付指令并帮助您完成支付。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        6
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为您提供安全保障
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为了保障您的账号安全、交易安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您使用我们的产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务过程中，经您授权我们会获取您的设备信息，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        包括您使用的设备属性、连接和状态信息，例如设备型号、设备标识符（如
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        IMEI/androidID/IDFA/OPENUDID/GUID/OAID
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        SIM
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        卡
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        IMSI
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ICCID
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        信息等）、设备
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        MAC
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        地址、软件列表、电信运营商等软硬件特征信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息等来综合判断您的账号及风险，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击等安全风险以及违反我们或关联方协议、政策或规则等行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        (“URL”)
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        7
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、我们可能间接收集的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为完成身份核验，保障账号安全，经您授权后我们可能会从第三方获取您的个人信息，以便于我们更好的为您提供相关服务。我们会依据法律法规的要求以及与第三方的约定，经您授权后向
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        的关联方、合作伙伴获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （二）您可以选择授权我们收集和使用个人信息的场景
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为向您提供个性化的服务，您可以选择使用我们提供的拓展功能，我们会在符合法律规定并根据您具体授权的情况下收集并使用如下信息。这类信息将在您选择的具体功能和场景中进行收集，如果您不提供这些信息，不会影响您使用
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、基于相机授权的拓展功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您可以选择开启系统的相机权限，通过使用拍照、录视频，扫码等功能授权腾宇一号访问您的相机，以便于您通过拍摄照片或录制视频等方式发布内容
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        ，如果您需要录制并发布有声视频时，您还需开启麦克风权限。我们会收集您上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现扫码功能，或者无法通过拍摄图片、视频等方式进行
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        评价
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        或互动，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        但不会影响您享受腾宇一号服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、基于相册授权的拓展功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您可以选择开启系统的相册权限，通过主动上传图片、视频等方式授权我们访问您的相册
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">，</span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        以便于您通过上传照片或上传视频等方式发布内容
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        。我们会收集您选择上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频等方式进行更换头像、发布带图
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        评价
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        等，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        但不会影响您享受腾宇一号服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        3
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、基于麦克风授权的拓展功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您可以选择开启系统的麦克风权限，使用语音技术来实现语音搜索等语音交互功能。
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们会收集您在使用智能语音技术过程中录入的语音信息用于机器识别、在线交互并满足您的搜索等需求。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现在线语音交互功能，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        但不会影响您享受腾宇一号服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        4
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、基于好友推荐的拓展功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们也可能基于您授权的设备信息、好友关系、日志信息为您推荐好友或将您推荐给其他用户，帮助您拓展社交圈。此项功能您可以在隐私设置中进行关闭或解除好友关系，也可以自主管理允许他人查看的范围（例如关注的人、粉丝、分享时展示的头像昵称等）。一旦关闭您将可能无法实现与您的好友在
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        进行分享交流，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        但不会影响您享受腾宇一号服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        5
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、基于日历授权的拓展功能
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您可以开启系统的日历权限，使用添加日历等功能记录腾宇一号相关服务的日程，我们会收集上述信息用于向您展示或定时提醒。
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        此项功能您可以在系统权限中关闭，一旦关闭您将可能无法享受日历记录或提醒功能，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        但不会影响您享受腾宇一号服务的基本功能。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （三）其他
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您可以通过腾宇一号为其他人预定各类产品
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        /
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        服务，并提供该实际服务接收人的有关信息，此前请您确保已取得相关人的授权。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        如果我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会单独征求您的授权同意。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （四）征得同意的例外
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为履行法定职责或者法定义务所必需；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        3
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        4
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        5
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        6
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、法律法规规定的其他情形。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        请注意，单独或与其他信息相结合无法识别您的身份或者与您直接建立联系的信息，不属于个人信息。如果我们将单独无法与任何特定个人建立联系的信息与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （五）个人信息的使用规则
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为满足您的个性化需求，维护、改进我们的产品或服务质量，我们会在符合法律规定并根据您具体授权的情况下使用如下信息：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、我们可能会收集您的浏览及搜索信息、行为偏好、位置信息等，以及将您在腾宇一号上使用某项服务中提供的信息与来自其他服务中的信息结合起来，进行综合统计、分析以形成用户画像，用来向您推荐或展示您可能感兴趣的产品
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        /
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        服务信息，或通过系统向您展示个性化的第三方推广信息。包括在
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        App
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        页面向您推送消息通知，为您提供智能推荐，通过短信、
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        APP
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、电子邮件等给您发送推送消息、推广信息或展示商业广告，通过电话进行回访、向您提供信息咨询等服务或邀请您参与服务、产品或功能有关的客户调研。例如将您在使用我们某项服务时收集的信息，用于在另一项服务中向您展示个性化的内容或广告。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        2
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、我们可能会收集您在参与产品
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        服务调查时主动向我们提供的信息，以及您与我们的关联方、合作伙伴之间互动时提供的相关信息，以便我们优化客户服务的质量与流程。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        3
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、我们可能将业务中收集的个人信息用于统计分析和改进运营，将已经去标识化无法识别您身份且不能复原的信息用于建立数据库并进行商业化利用。例如通过您所在的位置、偏好等进行统计分析，从而改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        二、我们如何公开披露您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （一）公开披露
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才可能公开披露您的个人信息：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        1
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        2
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        请注意，您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评论时选择上传包含个人信息的文字、图片或视频等各种形式的信息。请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        二
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ）公开披露个人信息时事先征得授权同意的例外
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        1
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、与国家安全、国防安全有关的；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        2
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、与公共安全、公共卫生、重大公共利益有关的；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        3
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、与犯罪侦查、起诉、审判和判决执行等有关的；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        4
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        5
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、其他维护公共利益的情形，例如您的信用评价信息需要被公开
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        /
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        共享；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        6
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、您自行向社会公众公开的个人信息；
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        7
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。但是您明确拒绝或者处理该信息侵害您重大利益的除外。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        根据法律规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，我们对此类数据的处理将无需另行向您通知并征得您的同意。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        三
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、我们如何保存和保护您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （一）个人信息的保存
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、保存期限：我们只会在达成本政策所述目的所需的期限内保留您的个人信息。，除非法律法规有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；保证我们为您提供服务的安全和质量；您是否同意更长的留存期间；是否存在关于保留期限的其他特别约定或法律法规规定。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。在您主动注销账号时，我们将根据法律法规的要求进行数据处理。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、保存地域：我们在中华人民共和国境内收集和产生的个人信息，将存储在中国境内，但以下情形除外：法律法规有明确规定的；单独征得您的授权同意。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在上述情形中，我们会根据法律法规要求履行相应流程和义务，并要求数据接收方按照不低于本隐私政策以及其他相关的安全保密措施来处理个人信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        3
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、终止运营：
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        如果发生终止运营等情形，我们将会至少提前
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        30
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        天通知您，并在终止运营后对您的个人信息根据法律法规的要求进行处理。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （二）个人信息的保护措施
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        1
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、数据安全措施
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        2
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、请您知悉并理解，
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账号或密码发生泄露，请您立即根据本隐私政策中提供的联系方式联络我们，以便我们采取相应措施。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        3
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        、安全事件
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在不幸发生个人信息安全事件后，我们会立即成立专项应急小组，启动应急预案，防止安全事件扩大，并按照法律法规的要求及时向您告知
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        :
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        四
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、您如何管理您的个人信息
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您对您的个人信息享有以下权利
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        :
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （一）您有权访问、更正、删除您的个人信息
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">，</span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        法律法规规定的例外情况除外。
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以通过以下方式管理您的信息
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        :
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        账号信息
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ——
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以访问、更正您账号中的个人资料及账号信息（身份认证信息除外）、账号绑定信息等，也可以更改您的密码、添加安全信息等，您可以通过访问
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        在设置中执行此类操作。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        地址信息
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ——
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以通过访问
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        随时添加、更改、删除
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        您的地址信息
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        搜索浏览信息
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ——
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以在
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        中访问或清除您的搜索历史记录以及管理其他数据。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        评论信息
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        ——
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以通过访问
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        访问、更正、清除您的评论内容。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        请您知悉，根据法律法规的要求及不同信息的技术条件需要，我们可能无法立即从系统中完全删除您所希望删除的相应信息，在此之前，我们将根据法规要求对相应信息仅进行存储并采取必要的安全保护措施方面的处理。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        如果您无法通过上述链接管理这些个人信息，您可以随时通过本隐私政策中提供的反馈方式联系我们。我们将在
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        15
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        天内回复您的访问请求。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （二）改变您授权同意的范围或撤回授权
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以通过在
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        中删除信息、更改隐私设置或者在系统中关闭设备权限功能等方式改变同意范围或撤回您的授权。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权已经开展的个人信息处理。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        （三）注销账号
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您有权注销您的
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        账号
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        ，您注销成功后，
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        除法律法规及相应的国家标准另有规定外，我们将删除您的个人信息或作匿名化处理。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        五
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、通知和修订
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整，对我们的基本情况、您的个人信息的处理目的方式种类和保存期限、您管理个人信息的方式、我们的联系方式发生变更的，我们会进行及时更新。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        我们会通过在我们移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        六
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、如何联系我们
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        您可以通过
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        腾宇一号
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        App
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        上提供的在线联系方式与我们联系，我们将在
      </span>
      <span style="color: #333333; font-family: Helvetica; font-size: 10pt">
        15
      </span>
      <span style="color: #333333; font-family: 宋体; font-size: 10pt">
        天内答复您的请求。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        &#xa0;
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        附录：
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        1
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中可能涉及到的个人信息包括但不限于：个人基本信息（包括姓名、电话号码、性别、住址、生日等）；个人身份信息（包括身份证、军官证、护照、驾驶证等）；网络身份标识信息（包括系统账号、
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        IP
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（包括银行账号、交易和消费记录、信贷记录以及虚拟财产信息等）；个人健康生理信息（包括病症、病历、病史等）；联系人信息（包括通讯录信息、好友列表等）；个人上网记录（包括网站浏览记录、点击记录等）；个人设备信息（包括唯一设备识别码等描述个人常用设备基本情况的信息）；个人位置信息（包括行踪轨迹、精准定位信息、住宿信息等）。
      </span>
    </p>
    <p style="background-color: #ffffff; line-height: 13.75pt; margin: 5pt 0pt">
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        2
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        、个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中可能涉及到的个人敏感信息包括：个人身份认证信息（包括身份证、军官证、护照、驾驶证、学生证等）；个人财产信息（银行账号、交易和消费记录、信贷记录以及虚拟财产信息等）；其他信息（行踪轨迹、通讯录信息、住宿信息、精准定位信息等）；
      </span>
      <span
        style="
          color: #333333;
          font-family: Helvetica;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        14
      </span>
      <span
        style="
          color: #333333;
          font-family: 宋体;
          font-size: 10pt;
          font-weight: bold;
        "
      >
        周岁以下的未成年人信息。
      </span>
    </p>
  </div>
</template>
